export default {
    name: ["", ""],
    logout: ["Log Out", "ចាកចេញ"],
    system: ["Ministry of Industry, Science, Technology & Innovation", "ក្រសួងឧស្សាហកម្ម វិទ្យាសាស្រ្ត បច្ចេកវិទ្យា និងនវានុវត្តន៍"],
    headTitle: ["SYSTEM LOG MANAGEMENT SYSTEM", "ប្រព័ន្ធគ្រប់គ្រងកំណត់ត្រាបច្ចេកវិទ្យាព័ត៌មាន"],
    dashboard: ["Dashboard", "ទំព័រដើម"],
    administrators: ["Administrators", "ការគ្រប់គ្រងអ្នកប្រើប្រាស់"],
    settings: ["System Settings", "ការកំណត់ប្រព័ន្ធ"],
    systemClients: ["System Clients", "ការគ្រប់គ្រងប្រព័ន្ធបុត្រសម្ព័ន្ធ"],
    systemLog: ["System Log", "ការគ្រប់គ្រងកំណត់ត្រា"],
    loginSystem: ["System Login", "ចូលប្រើប្រាស់ប្រព័ន្ធ"],
    login: ["Log In", "ចូលប្រព័ន្ធ"],
    technicalSupport: ["Technical Support", "គាំទ្រផ្នែកបច្ចេកទេស"],
    addNewAdministrator: ["Add New UserSingleName", "បង្កើតអ្នកប្រើប្រាស់ថ្មី"],
    settingName: ["Setting Name", "ឈ្មោះការកំណត់"],
    required: ["* required", "* តម្រូវបំពេញ"],
    settingValue: ["Setting Data", "ទិន្នន័យកំណត់"],
    update: ["Update", "ធ្វើបច្ចុប្បន្នភាព"],
    statistics: ["Overall Statistics", "ទិន្នន័យស្ថិតិសរុប"],
    statisticsToday: ["Today", "ទិន្នន័យស្ថិតិប្រចាំថ្ងៃ"],
    statisticsRange: ["Search by Date Range", "ស្វែងរកទិន្នន័យស្ថិតិ"],
    totalLog: ["Total Logs", "ចំនួនកំណត់ត្រាទាំងអស់"],
    totalSystemClient: ["Total System Clients", "ចំនួនប្រព័ន្ធបុត្រសម្ព័ន្ធទាំងអស់"],
    totalUser: ["Total Users", "ចំនួនអ្នកគ្រប់គ្រងទាំងអស់"],
    all: ["All", "ទាំងអស់"],
    status: ["Status", "ស្ថានភាព"],
    action: ["Action", "សកម្មភាព"],
    lastUpdate: ["Last Updated", "កែប្រែចុងក្រោយ"],
    totalSetting: ["Total Settings", "ចំនួនការកំណត់ទាំងអស់"],
    normalLog: ["Normal Log", "កំណត់ត្រាធម្មតា"],
    warningLog: ["Warning Log", "កំណត់ត្រាការព្រមាន"],
    criticalLog: ["Critical Log", "កំណត់ត្រាកំហុសធ្ងន់ធ្ងរ"],
    startDate: ["Start Date", "ថ្ងៃចាប់ផ្តើម"],
    endDate: ["End Date", "ថ្ងៃបញ្ចប់"],
    active: ["Active", "ដំណើរការ"],
    showMore: ["Show more", "បង្ហាញបន្ថែម"],
    search: ["Search", "ស្វែងរក"],
    edit: ["Edit", "កែប្រែ"],
    enable: ["Enable", "ដាក់ដំណើរការ"],
    disable: ["Disable", "បញ្ចប់ដំណើរការ"],
    delete: ["Delete", "លុបចេញ"],
    cancel: ["Cancel", "បោះបង់"],
    statusAll: ["Status (All)", "ស្ថានភាព (ទាំងអស់)"],
    typeAll: ["Type (All)", "ប្រភេទ (ទាំងអស់)"],
    type: ["Type", "ប្រភេទ"],
    searchAdministrator: ["Search users", "ស្វែងរកអ្នកគ្រប់គ្រង"],
    disabled: ["Disabled", "មិនដំណើរការ"],
    editAdministrator: ["Edit Administrator", "កែប្រែព័ត៌មានអ្នកគ្រប់គ្រង"],
    searchClient: ["Search System Clients", "ស្វែងរកប្រព័ន្ធបុត្រសម្ព័ន្ធ"],
    newClient: ["New System Client", "បង្កើតប្រព័ន្ធបុត្រសម្ព័ន្ធថ្មី"],
    clientName: ["System Client Name", "ឈ្មោះប្រព័ន្ធបុត្រសម្ព័ន្ធ"],
    clientTelegramBotToken: ["Telegram Bot Token", "តេឡេក្រាម Bot Token"],
    clientTelegramChatId: ["Telegram Group ID", "តេឡេក្រាមក្រុម ID"],
    noClient: ["No system clients available.", "មិនមានប្រព័ន្ធបុត្រសម្ព័ន្ធទេ។"],
    sendNotificationNormalLog: ["Normal Log", "កំណត់ត្រាធម្មតា"],
    sendNotificationWarningLog: ["Warning Log", "កំណត់ត្រាការព្រមាន"],
    sendNotificationCriticalLog: ["Critical Log", "កំណត់ត្រាកំហុសធ្ងន់ធ្ងរ"],
    editClient: ["Edit System Client", "កែប្រែព័ត៌មានប្រព័ន្ធបុត្រសម្ព័ន្ធ"],
    deleteThis: ["Delete", "លុប"],
    disableThis: ["Disable", "បញ្ចប់ដំណើរការ "],
    view: ["View Detail", "មើលលម្អិត"],
    revokeKey: ["Revoke API Key", "ផ្លាស់ប្តូរ API Key "],
    clientInfo: ["System Client Information", "ព័ត៌មានប្រព័ន្ធបុត្រសម្ព័ន្ធ"],
    code: ["System Code", "លេខកូដប្រព័ន្ធ"],
    apiKey: ["API Key", "លេខកូដ API Key"],
    updatedDate: ["Last Updated", "ថ្ងៃកែប្រែចុងក្រោយ"],
    integration: ["API Endpoint", "របៀបភ្ជាប់ API Endpoint"],
    notification: ["Telegram Notifications", "ការជូនដំណឹងតាមតេឡេក្រាម"],
    channelList: ["Notification Channel", "ឆានែលសម្រាប់ការជូនដំណឹង"],
    mainChannel: ["Main Notification Channel", "ឆានែលគោលសម្រាប់ជូនដំណឹង"],
    channelName: ["Channel Name", "ឈ្មោះឆានែល"],
    channelCode: ["Channel Code", "លេខកូដឆានែល"],
    newChannel: ["New Channel", "បង្កើតឆានែលថ្មី"],
    editChannel: ["Edit Channel", "កែប្រែឆានែល"],
    channelSlug: ["Channel Slug", "ពាក្យកាត់ឈ្មោះឆានែល"],
    notificationSetting: ["Telegram Notification Settings", "ការកំណត់ការជូនដំណឹងតាមតេឡេក្រាម"],
    userName: ["Name", "ឈ្មោះអ្នកគ្រប់គ្រង"],
    userContact: ["Contact", "ទំនាក់ទំនង"],
    userRole: ["Role", "តួនាទី"],
    roleSuperAdmin: ["Super Administrator", "អ្នកគ្រប់គ្រងជាន់ខ្ពស់"],
    roleUser: ["Administrator", "អ្នកគ្រប់គ្រងទូទៅ"],
    userUsername: ["Login Name", "ឈ្មោះចូលប្រព័ន្ធ"],
    createdDate: ["Created Date", "ថ្ងៃបង្កើត"],
    password: ["Password", "ពាក្យសម្ងាត់"],
    confirmPassword: ["Confirm Password", "បញ្ជាក់ពាក្យសម្ងាត់"],
    totalChannel: ["Total Channel", "ចំនួនឆានែល"],
    lastLog: ["Last Log", "កំណត់ត្រាចុងក្រោយ"],
    totalClientLog: ["Total Log", "ចំនួនកំណត់ត្រា"],
    refreshRate: ["Refresh Every", "ធ្វើបច្ចុប្បន្នភាពរៀងរាល់ពេល"],
    second: ["seconds", "វិនាទី"],
    channelCodeAll: ["Channel Code (All)", "លេខកូដឆានែល (ទាំងអស់)"],
    searchLog: ["Search by keywords", "ស្វែងរកតាមរយៈពាក្យ"],
    noLog: ["No log available", "មិនមានកំណត់ត្រា"],
    code: ["Code", "លេខកូដ"],
    logType: ["Log Type", "ប្រភេទកំណត់ត្រា"],
    description: ["Description", "ការពិពណ៌នា"],
    phoneNumber: ["Phone Number", "លេខទូរស័ព្ទ"],
    singleId: [" using MISTI Single Identity System", "តាមរយៈប្រព័ន្ធគ្រប់គ្រងអត្តសញ្ញាណឌីជីថលតែមួយ"],
    logInfo: ["Information", "ព័ត៌មាន"],
    searchUser: ["Search", "ស្វែងរក"],
    singleId: ["MISTI Single ID", "MISTI Single ID"],
    singleIdCode: ["User Code", "លេខកូដអ្នកប្រើប្រាស់"],
    personal_code: ["National ID", "លេខអត្តសញ្ញាណប័ណ្ណ"],
    government_id: ["Government Official ID", "លេខប័ណ្ណមន្រ្តីរាជការ"],
    userSingleName: ["User Name", "ឈ្មោះអ្នកប្រើប្រាស់"],
    phone_number: ["Phone Number", "លេខទូរស័ព្ទ"],
    email: ["Email", "អុីម៉ែល"],
}


// WEBPACK FOOTER //
// ./src/config/locale.js